import {Component, OnInit} from '@angular/core';
import {DropzoneConfigInterface} from 'ngx-dropzone-wrapper';
import {Certificate} from '../models/certificate';
import {CertificateStatus} from '../models/certificate-status.enum';
import {CertificateService} from '../certificate.service';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {NgbDateAdapter, NgbDateNativeAdapter} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

const institutions = [
  'NHL Stenden Hogeschool (Friesland, hbo)',
  'Christelijke Hogeschool Ede (Gelderland, hbo)',
  'Aeres Hogeschool (Gelderland, hbo)',
  'ArtEZ (Gelderland, hbo)',
  'Hogeschool Van Hall Larenstein (Gelderland, hbo)',
  'Iselinge Hogeschool (Gelderland, hbo)',
  'Hogeschool van Arnhem en Nijmegen (Gelderland, hbo)',
  'Hanzehogeschool Groningen (Groningen, hbo)',
  'Zuyd Hogeschool (Limburg, hbo)',
  'Avans Hogeschool (Noord-Brabant, hbo)',
  'Breda University of Applied Sciences (Noord-Brabant, hbo)',
  'HAS Hogeschool (Noord-Brabant, hbo)',
  'Fontys Hogescholen (Noord-Brabant, hbo)',
  'Pedagogische Hogeschool De Kempel (Noord-Brabant, hbo)',
  'Design Academy Eindhoven (Noord-Brabant, hbo)',
  'Gerrit Rietveld Academie (Noord-Holland, hbo)',
  'Amsterdamse Hogeschool voor de Kunsten (Noord-Holland, hbo)',
  'Hogeschool IPABO Amsterdam Alkmaar (Noord-Holland, hbo)',
  'Hogeschool van Amsterdam (Noord-Holland, hbo)',
  'Katholieke PABO Zwolle (Overijssel, hbo)',
  'Stichting Hogeschool Viaa (Overijssel, hbo)',
  'Saxion Hogeschool (Overijssel, hbo)',
  'Christelijke Hogeschool Windesheim (Overijssel, hbo)',
  'Hogeschool voor de Kunsten Utrecht (Utrecht, hbo)',
  'Hogeschool Utrecht (Utrecht, hbo)',
  'Marnix Academie (Utrecht, hbo)',
  'HZ University of Applied Sciences (Zeeland, hbo)',
  'Codarts, Hogeschool voor de Kunsten (Zuid-Holland, hbo)',
  'Hogeschool Leiden (Zuid-Holland, hbo)',
  'Hogeschool Rotterdam (Zuid-Holland, hbo)',
  'Hogeschool der Kunsten Den Haag (Zuid-Holland, hbo)',
  'Driestar educatief (Zuid-Holland, hbo)',
  'Hogeschool INHOLLAND (Zuid-Holland, hbo)',
  'De Haagse Hogeschool (Zuid-Holland, hbo)',
  'Hogeschool Thomas More (Zuid-Holland, hbo)',
  'Hotelschool The Hague (Zuid-Holland, hbo)',
  'Wageningen University (Gelderland, wo)',
  'Theologische Universiteit Apeldoorn (Gelderland, wo)',
  'Radboud Universiteit Nijmegen (Gelderland, wo)',
  'Rijksuniversiteit Groningen (Groningen, wo)',
  'Universiteit Maastricht (Limburg, wo)',
  'Open Universiteit Nederland (Limburg, wo)',
  'Technische Universiteit Eindhoven (Noord-Brabant, wo)',
  'Tilburg University (Noord-Brabant, wo)',
  'Protestantse Theologische Universiteit (Noord-Holland, wo)',
  'Universiteit van Amsterdam (Noord-Holland, wo)',
  'Vrije Universiteit Amsterdam (Noord-Holland, wo)',
  'Universiteit Twente (Overijssel, wo)',
  'Theologische Universiteit van de Gereformeerde Kerk (Vrijg) in Nederland (Overijssel, wo)',
  'Universiteit Utrecht (Utrecht, wo)',
  'Universiteit voor Humanistiek (Utrecht, wo)',
  'Erasmus Universiteit Rotterdam (Zuid-Holland, wo)',
  'Technische Universiteit Delft (Zuid-Holland, wo)',
  'Universiteit Leiden (Zuid-Holland, wo)',
  'Xebia'
];

@Component({
  selector: 'app-create-certificate',
  templateUrl: './create-certificate.component.html',
  styleUrls: [
    './create-certificate.component.css',
    '../../vendor/libs/ngx-dropzone-wrapper/ngx-dropzone-wrapper.scss',
    '../../vendor/libs/ngb-datepicker/ngb-datepicker.scss',
  ],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class CreateCertificateComponent implements OnInit {

  public certificate: Certificate;

  constructor(private certificateService: CertificateService, private router: Router) {
    this.resetCertificate();
  }

  fileUploaded(): void {
    this.certificate.issuer = 'Xebia';
    let randomNumber: number = Math.round(Math.random() * 100000);
    this.certificate.identifier = 'C00' + randomNumber;
    this.certificate.description = 'Scrum Certificate 2020';
    this.certificate.expiryDate = new Date();
  }

  private resetCertificate(): void {
    this.certificate = new Certificate({
      status: CertificateStatus.PENDING_APPROVAL,
      expiryDate: null,
      issuer: '',
      description: '',
      identifier: '',
      owner: 'professional@otentica.nl',
      thumbnail: 'cert2.png',
      filename: 'cert2.pdf'
    });
  }

  addCertificate(): void {
    this.certificateService.addCertificate(this.certificate);
    this.resetCertificate();
    this.router.navigate(['/certificates']);
  }

  ngOnInit(): void {
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(0),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : institutions.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  dropzoneConfig: DropzoneConfigInterface = {
    url: '/upload',
    parallelUploads: 2,
    maxFilesize:     50000,
    filesizeBase:    1000,
    addRemoveLinks:  true,
    previewTemplate: `
<div class="dz-preview dz-file-preview">
  <div class="dz-details">
    <div class="dz-thumbnail">
      <img data-dz-thumbnail>
      <span class="dz-nopreview">No preview</span>
      <div class="dz-success-mark"></div>
      <div class="dz-error-mark"></div>
      <div class="dz-error-message"><span data-dz-errormessage></span></div>
      <div class="progress">
        <div class="progress-bar progress-bar-primary"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          data-dz-uploadprogress></div>
      </div>
    </div>
    <div class="dz-filename" data-dz-name></div>
    <div class="dz-size" data-dz-size></div>
  </div>
</div>`
  };

}
